import axios from 'axios';
import * as Routes from '@/modules/routes';

import { UserInfo } from './types';

export let userInfo: UserInfo = {};
axios.get<UserInfo>(Routes.plato_api_me_path()).then((res) => {
  userInfo = res.data;
});
